import axios from "axios";

export default function getNodeSnRange({ id }) {
  return new Promise((resolve, reject) =>
    axios
      .get(`/serialnumber/system-admin/api/v1/serialnumber/${id}/get-range`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
